<template>
  <div class="bee-page-wrapper">
    <div v-if="showSizer || showElevator" :class="optsClasses">
      <div v-if="showSizer" :class="sizerClasses">
        <bee-select v-model="currentPageSize"  @on-change="changeSize">
          <bee-option v-for="item in pageSizeOpts" :key="item" :value="item" style="text-align:center;">{{ item }}</bee-option>
        </bee-select>
      </div>
      <div v-if="showElevator" :class="ElevatorClasses">
        跳至
        <input
          type="text"
          :value="current"
          autocomplete="off"
          spellcheck="false"
          @keyup.enter="changePage"
        >
        页
      </div>
    </div>
  </div>
</template>

<script>
const prefixCls = 'bee-page'
function isValueNumber(value) {
  return (/^[1-9][0-9]*$/).test(value + '')
}
export default {
  name: 'options',
  props: {
    pageSizeOpts: Array,
    showSizer: Boolean,
    showElevator: Boolean,
    current: Number,
    pageSize: Number,
    allPages: Number,
    isSmall: Boolean,
    placement: String,
    transfer: Boolean
  },
  data() {
    return {
      currentPageSize: this.pageSize
    }
  },
  computed: {
    optsClasses() {
      return [
        `${prefixCls}-options`
      ]
    },
    sizerClasses() {
      return [
        `${prefixCls}-options-sizer`
      ]
    },
    ElevatorClasses() {
      return [
        `${prefixCls}-options-elevator`
      ]
    }
  },
  components: {
  },
  watch: {

  },
  methods: {
    changeSize() {
      this.$emit('on-size', this.currentPageSize)
    },
    changePage(event) {
      let val = event.target.value.trim()
      let page = 0

      if(isValueNumber(val)) {
        val = Number(val)
        if(val !== this.current) {
          const allPages = this.allPages
          if(val > allPages) {
            page = allPages
          } else {
            page = val
          }
        }
      } else {
        page = 1
      }
      if(page) {
        this.$emit('on-page', page)
        event.target.value = page
      }
    }
  },
  created() {

  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/options.vue